import { Mesh, PlaneGeometry } from 'three/webgpu'
import WarpPanelMaterial from '../materials/WarpPanelMaterial'

export default class RoundedPanel extends Mesh {
	static defaults = {
		top: 0x000000,
		bottom: 0x000000,
		radius: 0,
		warp: 0.8,
		waves: 3,
		ripple: 0.08,
		bounce: 1,
		falloff: 0.75,
		segments: 64,
	}

	constructor(options = {}) {
		const { segments, radius, ...material } = { ...RoundedPanel.defaults, ...options }

		super(new PlaneGeometry(1, 1, segments, segments), new WarpPanelMaterial(material))
		this.radius = radius
		this.material.radius.value = radius
	}

	resize(rect) {
		this.material.size.value.set(rect.width, rect.height)
	}

	morph(progress, from, to) {
		this.material.progress.value = progress
		this.material.radius.value = this.radius * (1 - progress)
		this.material.delta.value.set(to.x - from.x, to.y - from.y, to.z - from.z, to.w - from.w)
	}

	dispose() {
		this.geometry.dispose()
		this.material.dispose()
	}
}
